/** @format */

export interface IPromotion {
  dataEm: string;
  details: string;
  detailsMessage: string;
  message: string;
  url: string;
  backgroundColor?: string;
  textColor?: string;
}
